import Choices from 'choices.js';

export default function selectChoices({main, on, elm, state}) {
    const select = elm.querySelector('select');
    const data = state.get();

    const checkSvg = `
        <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4.33337L5.52941 9.00003L12 1.00003" stroke="#FF3700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;

    let choices;

    main(() => {
        init();

        on('click', '.choices__list-close', close);

		if (elm.dataset.source) {
			on('search', 'select', onSearch);
		}
    });

    const init = function() {
		const config = {
			itemSelectText: '',
			placeholder: true,
			placeholderValue: data.placeholder,
			searchPlaceholderValue: data.searchPlaceholder,
			shouldSort: false,
			classNames: {
				containerOuter: ['choices', data.theme ? `choices--${data.theme}` : `choices--dark`],
			},
			callbackOnCreateTemplates: function(strToEl, escapeForTemplate, getClassNames) {
				return {
					item: itemTemplate.bind(this, strToEl, escapeForTemplate, getClassNames),
					choice: choiceTemplate.bind(this, strToEl, escapeForTemplate, getClassNames),
				};
			},
			callbackOnInit: function() {
				choicesAfterInit.bind(this)();
			},
		};

		if (elm.dataset.source) {
			config.searchChoices = false;
			config.searchFloor = 1;
			config.searchResultLimit = 10;
		}

        choices = new Choices(select, config);

        if (data.disabled) {
            choices.disable();
        }

        elm.choices = choices;
		elm.autocomplete = autocomplete;
    };

    const close = function() {
        choices.hideDropdown();
    };

	const onSearch = async function(e) {
		const searchTerm = e.detail.value;

		await elm.autocomplete(searchTerm);
	}

	const autocomplete = async function (searchTerm) {
		const action = elm.dataset.source;

		let filter = `search=${searchTerm}`;
		if (elm.dataset.dependency) {
			const el = document.getElementById(elm.dataset.dependency);
			filter += `&${elm.dataset.dependency}=${el.value}`;
		}

		try {
			const response = await fetch(`${action}&${filter}`);
			const results = await response.json();

			elm.choices.clearChoices();
			elm.choices.setChoices(results, 'value', 'label', true);
		} catch (error) {
			console.error('Error fetching dynamic search results:', error);
		}
	};

    const itemTemplate = function(strToEl, escapeForTemplate, getClassNames, { classNames }, data) {
        return strToEl(`
            <div class="${getClassNames(classNames.item).join(' ')} ${getClassNames(data.highlighted ? classNames.highlightedState : classNames.itemSelectable).join(' ')} ${data.placeholder ? classNames.placeholder : ''}"
                data-item data-id="${data.id}"
                data-value="${escapeForTemplate(data.value)}"
                role="option"
                ${data.active ? 'aria-selected="true"' : ''} ${data.disabled ? 'aria-disabled="true"' : ''}
            >
                ${!data.placeholder ? `<span class="choices__placeholder">${this.config.placeholderValue}</span>` : ''}
                <span class="choices__label">${data.label}</span>
            </div>
        `);
    };

    const choiceTemplate = function(strToEl, escapeForTemplate, getClassNames, { classNames }, data) {
        let imgMarkup = null;

        if (data.customProperties?.image) {
            imgMarkup = `<span class="choices__img"><img src="${data.customProperties.image}" alt="${data.label}" /></span>`;
        }

        return strToEl(`
            <div class="${getClassNames(classNames.item).join(' ')} ${getClassNames(classNames.itemChoice).join(' ')} ${getClassNames(data.disabled ? classNames.itemDisabled : classNames.itemSelectable).join(' ')} ${data.selected ? 'is-selected' : ''}"
                 data-select-text="${this.config.itemSelectText}"
                 data-choice
                 ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
                 data-id="${data.id}"
                 data-value="${escapeForTemplate(data.value)}"
                 ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}
            >
                ${imgMarkup ? imgMarkup : ''}
                <span class="choices__label">${data.label}</span>
                ${data.selected ? '<span class="choices__check">' + checkSvg + '</span>' : ''}
            </div>
        `);
    };

    const choicesAfterInit = function () {
        const dropdown = this.dropdown.element;
        const headerMarkup = `
            <div class="choices__list-header">
                <div class="choices__list-title">${this.config.placeholderValue}</div>
                <button type="button" class="btn btn--with-icon choices__list-close" aria-label="Закрыть">
                    <svg>
                        <use href="/extension/evasota/catalog/view/assets/img/icons.svg#icon-close-2"></use>
                    </svg>
                </button>
            </div>
        `;

        dropdown.insertAdjacentHTML('afterbegin', headerMarkup);
    };
};

export const model = ({elm}) => {
    return {
        placeholder: elm.dataset.placeholder ?? '',
        searchPlaceholder: elm.dataset.searchPlaceholder ?? '',
        theme: elm.dataset.theme ?? '',
        disabled: elm.dataset.disabled ?? false,
    };
};
